import React from "react";

import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { useDispatch } from "react-redux";
import UploadFileForm from "./UploadFileForm";

export default function UploadFileModal({
  name = "uploadFileModal",
  successCallback = ({ fileId, fileData }) => {},
}) {

  const dispatch = useDispatch();

  const callback = ({ fileId, fileData }) => {
    dispatch(modalsActions.closeModal("uploadFileModal"));
    successCallback({ fileId, fileData });
  };

  return (
    <ReduxModal
      name={name}
      title="Upload Data"
      fullWidth
      maxWidth="sm"
      closeButtonProps={{
        variant: "outlined",
      }}
    >
      <UploadFileForm successCallback={callback} />
    </ReduxModal>
  );
  
}
